import React, { useState } from 'react';
import { PhoneIcon, MailIcon, UploadIcon, XIcon, ImageIcon } from 'lucide-react';
const Hero = () => {
  const [files, setFiles] = useState([]);
  const handleFileChange = e => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFiles(prev => [...prev, ...newFiles]);
    }
  };
  const removeFile = index => {
    setFiles(files.filter((_, i) => i !== index));
  };
  return <section className="relative w-full bg-gray-900 text-white" data-id="element-142">
      <div className="absolute inset-0 bg-cover bg-center opacity-40" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80')"
    }} data-id="element-143"></div>
      <div className="container mx-auto px-4 py-24 relative z-10 flex flex-col md:flex-row" data-id="element-144">
        <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-145">
          <h2 className="text-4xl font-bold mb-6" data-id="element-146">
            Mööbli montaaž ja paigaldus
          </h2>
          <p className="text-xl mb-8" data-id="element-147">Viljandimaal ja üle Eesti</p>
          <div className="flex items-center mb-4" data-id="element-148">
            <PhoneIcon size={20} className="mr-2" data-id="element-149" />
            <a href="tel:55613203" className="hover:underline" data-id="element-150">
              55613203
            </a>
          </div>
          <div className="flex items-center" data-id="element-151">
            <MailIcon size={20} className="mr-2" data-id="element-152" />
            <a href="mailto:veikokirsman@gmail.com" className="hover:underline" data-id="element-153">
              veikokirsman@gmail.com
            </a>
          </div>
        </div>
        <div className="md:w-1/2 bg-white p-6 rounded-lg shadow-lg text-gray-800" data-id="element-154">
          <h3 className="text-2xl font-semibold mb-4 text-blue-900" data-id="element-155">
            Küsi pakkumist
          </h3>
          <form data-id="element-156">
            <div className="mb-4" data-id="element-157">
              <label htmlFor="email" className="block text-sm font-medium mb-1" data-id="element-158">
                E-post *
              </label>
              <input type="email" id="email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-159" />
            </div>
            <div className="mb-4" data-id="element-160">
              <label htmlFor="address" className="block text-sm font-medium mb-1" data-id="element-161">
                Tööde aadress *
              </label>
              <input type="text" id="address" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Tänav, maja, korter, linn" required data-id="element-162" />
            </div>
            <div className="mb-4" data-id="element-163">
              <label htmlFor="message" className="block text-sm font-medium mb-1" data-id="element-164">
                Kirjeldus/mõtted/küsimused/ideed *
              </label>
              <textarea id="message" rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Kirjeldage oma soove ja vajadusi võimalikult täpselt" required data-id="element-165"></textarea>
            </div>
            <div className="mb-4" data-id="element-166">
              <label className="block text-sm font-medium mb-1" data-id="element-167">
                Piltide lisamine
              </label>
              <div className="flex items-center justify-center w-full" data-id="element-168">
                <label className="flex flex-col items-center justify-center w-full h-24 border-2 border-dashed rounded-lg cursor-pointer border-gray-300 bg-gray-50 hover:bg-gray-100" data-id="element-169">
                  <div className="flex flex-col items-center justify-center pt-3 pb-3" data-id="element-170">
                    <UploadIcon size={24} className="text-gray-400 mb-1" data-id="element-171" />
                    <p className="mb-1 text-xs text-gray-500" data-id="element-172">
                      <span className="font-semibold" data-id="element-173">
                        Kliki failide lisamiseks
                      </span>{' '}
                      või lohista failid siia
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-174">
                      PNG, JPG või JPEG (max 10MB)
                    </p>
                  </div>
                  <input type="file" className="hidden" multiple accept="image/png, image/jpeg, image/jpg" onChange={handleFileChange} data-id="element-175" />
                </label>
              </div>
              {files.length > 0 && <div className="mt-2" data-id="element-176">
                  <p className="text-xs font-medium mb-1" data-id="element-177">Lisatud pildid:</p>
                  <div className="grid grid-cols-3 gap-1" data-id="element-178">
                    {files.map((file, index) => <div key={index} className="relative group" data-id="element-179">
                        <div className="h-16 rounded-md bg-gray-100 flex items-center justify-center border border-gray-200 overflow-hidden" data-id="element-180">
                          <div className="absolute inset-0 flex items-center justify-center" data-id="element-181">
                            {file.type.startsWith('image/') ? <img src={URL.createObjectURL(file)} alt={`Upload ${index + 1}`} className="h-full w-full object-cover" data-id="element-182" /> : <ImageIcon size={16} className="text-gray-400" data-id="element-183" />}
                          </div>
                          <button type="button" onClick={() => removeFile(index)} className="absolute top-0.5 right-0.5 bg-red-500 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-184">
                            <XIcon size={12} data-id="element-185" />
                          </button>
                        </div>
                      </div>)}
                  </div>
                </div>}
            </div>
            <button type="submit" className="w-full bg-blue-900 text-white py-2 px-4 rounded-md hover:bg-blue-800 transition duration-300" data-id="element-186">
              Saada päring
            </button>
          </form>
        </div>
      </div>
    </section>;
};
export default Hero;